import { ProgressNotifier } from "./ProgressNotifier";

/* I'm an Action that the user performs. Instances of me would appear in:
* Context menus.
* As the underlying model for a button.
* As the underlying model for a progress bar.
* As the underlying model for a keyboard shortcut.

I have a label, icon and a bit of code for when I'm activated.

You need to implement me by creating a sub-class. If you want me to 
access other objects, they need to be passed in to me in the constructor.

*/


export abstract class Action {
    public abstract label : string ;
    public description : string = "";
    // TODO abstract getIcon() : Path;
    // TODO abstract getPreferedKeyboardShortcut() : KeyboardShortcut

    /* Can I perform myself? If not, any buttons or 
    menu entries that show me should be shown as 'disabled'. */
    canDo() { return true }; // maybe also return a tooltip?

    /* Perform this action. */    
    abstract do(p? : ProgressNotifier) : void;

    public notifyListeners() {
        for (let each of this.listeners) {
            each.actionWasTriggered(this);
        }
    }

    /* TODO
    undo() {... }

    isUndoable() {
        return false;
    }*/

    private listeners : ActionTriggeredListener[] = []
    addActionTriggeredObserver(listener: ActionTriggeredListener) {
        this.listeners.push(listener);
    }
}

/* I'm a sub-menu inside a context menu. I have no behaviour other than being able to display another menu. */
export abstract class ActionMenu extends Action {

    public abstract menu: Action[];

    do(p?: ProgressNotifier | undefined): void {
    }

    canDo() {
        return true;
    }

}

export interface ActionTriggeredListener {
    actionWasTriggered(a : Action) : void;
}